<div class="relative min-h-screen overflow-hidden bg-gradient-to-b from-slate-50 via-white to-slate-100 dark:from-gray-950 dark:via-gray-950 dark:to-gray-900">
  <div class="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-brand-400/20 blur-3xl dark:bg-brand-500/20"></div>
  <div class="pointer-events-none absolute -bottom-24 left-0 h-72 w-72 rounded-full bg-indigo-400/20 blur-3xl dark:bg-indigo-500/20"></div>

  <div class="mx-auto flex min-h-screen max-w-5xl flex-col items-center justify-center px-6 py-16 text-center">
    <div class="w-full max-w-2xl rounded-3xl border border-gray-200/70 bg-white/80 p-8 shadow-theme-sm backdrop-blur-sm transition hover:-translate-y-0.5 dark:border-gray-800/70 dark:bg-gray-900/70 sm:p-10">
      <div class="mb-6 flex items-center justify-center">
        <img
          class="h-10 dark:hidden"
          src="/assets/images/logo/new-logo.svg"
          alt="CitaLink Pro"
        />
        <img
          class="hidden h-10 dark:block"
          src="/assets/images/logo/new-logo-dark.svg"
          alt="CitaLink Pro"
        />
      </div>
      <div class="mx-auto mb-6 inline-flex animate-pulse items-center rounded-full bg-brand-50 px-4 py-1 text-xs font-semibold uppercase tracking-widest text-brand-700 dark:bg-brand-500/10 dark:text-brand-200">
        Página no encontrada
      </div>

      <h1 class="mb-3 text-6xl font-extrabold tracking-tight sm:text-7xl">
        <span class="bg-gradient-to-r from-brand-500 via-indigo-500 to-purple-500 bg-clip-text text-transparent">
          404
        </span>
      </h1>
      <p class="text-lg font-semibold text-gray-800 dark:text-gray-100">
        No encontramos esa página
      </p>
      <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">
        Revisa la URL o vuelve al inicio para retomar tu trabajo.
      </p>

      <div class="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <a
          routerLink="/"
          class="inline-flex w-full items-center justify-center rounded-xl bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white shadow-theme-xs transition hover:-translate-y-0.5 hover:bg-brand-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-gray-900 sm:w-auto"
          aria-label="Volver al inicio"
        >
          Volver al inicio
        </a>
        <button
          type="button"
          (click)="goBack()"
          class="inline-flex w-full items-center justify-center rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-700 shadow-theme-xs transition hover:-translate-y-0.5 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800 dark:focus-visible:ring-offset-gray-900 sm:w-auto"
          aria-label="Ir atrás"
        >
          Ir atrás
        </button>
      </div>
    </div>

    <div class="mt-8 w-full max-w-3xl text-left">
      <div class="rounded-2xl border border-gray-200/70 bg-white/70 p-6 shadow-theme-xs backdrop-blur-sm dark:border-gray-800/70 dark:bg-gray-900/60">
        <p class="text-sm font-semibold text-gray-700 dark:text-gray-200">
          Sugerencias rápidas
        </p>
        <div class="mt-4 grid gap-3 sm:grid-cols-2">
          <a
            routerLink="/"
            class="group inline-flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-700 transition hover:border-brand-200 hover:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-200 dark:hover:border-brand-500/40 dark:hover:bg-brand-500/10"
            aria-label="Ir a Inicio"
          >
            Inicio
            <span class="text-gray-400 transition group-hover:text-brand-500">→</span>
          </a>
          <a
            routerLink="/dashboard"
            class="group inline-flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-700 transition hover:border-brand-200 hover:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-200 dark:hover:border-brand-500/40 dark:hover:bg-brand-500/10"
            aria-label="Ir a Dashboard"
          >
            Dashboard
            <span class="text-gray-400 transition group-hover:text-brand-500">→</span>
          </a>
          <a
            routerLink="/user/profile"
            class="group inline-flex items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm font-medium text-gray-700 transition hover:border-brand-200 hover:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-200 dark:hover:border-brand-500/40 dark:hover:bg-brand-500/10"
            aria-label="Ir a Perfil"
          >
            Perfil
            <span class="text-gray-400 transition group-hover:text-brand-500">→</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
